import React, { useState } from "react";
import LinesEllipsis from "react-lines-ellipsis";
import styles from "@kursk/components/ui/ContactsBlock/ContactsBlock.module.scss";
import { CommentTooltip } from "@kursk/components/ui/CommentTooltip/CommentTooltip";

interface IProps {
  text: string,
}

export const ShowMoreWithToolTip = ({ text }: IProps) => {

  const [isShowMoreVisible, setIsShowMoreVisible] = useState<boolean>(false)

  const handleAddressReflow = (rleState) => {
    const {
      clamped,
    } = rleState

    setIsShowMoreVisible(clamped)
  }

  return (
    <>
      {text && <LinesEllipsis
        text={text}
        maxLine={1}
        ellipsis='...'
        trimRight
        basedOn='letters'
        className={styles.contacts_comment}
        onReflow={handleAddressReflow}
      />}
      {text && isShowMoreVisible && (
        <CommentTooltip text={text} offset={[-30, -10]}>
          {isShowMoreVisible && <div className={styles.contacts_showMore}>
            Читать полностью
          </div>}
        </CommentTooltip>
      )}
    </>
  )
}
